import { ReactNode } from "react";
//ASSETS

import { ReactComponent as RoundedQuarterCircle } from "assets/svg/RoundedQuarterCircle.svg";
import { ReactComponent as Megaphone } from "assets/svg/Megaphone.svg";
import { ReactComponent as Book } from "assets/svg/Book.svg";
import { ReactComponent as Libra } from "assets/svg/Libra.svg";

//MISC

import { appRoutes } from "config/AppRoutesConfig";
import { COLORS } from "constants/variables";

//LIBRARY

import { useTranslation } from "react-i18next";

export enum TextPlacement {
  right = "right",
  left = "left",
}

export interface LegislationCard {
  id: number;
  title: string;
  backgroundColor: string;
  textColor: string;
  svg: ReactNode;
  svgPosition: { bottom?: string; left?: string; right?: string; top?: string };
  svgTransform?: string;
  svgOpacity?: number;
  route: string;
  gridArea: string;
  height: string;
  textPlacement: TextPlacement;
}

export const useLegislationCards = (): LegislationCard[] => {
  const { t } = useTranslation();

  return [
    {
      id: 1,
      title: t("view.legislation.legislation"),
      backgroundColor: COLORS.FaluRed,
      textColor: COLORS.Background,
      svg: <Libra />,
      svgPosition: { bottom: "10px", right: "10px" },
      height: "legislation",
      route: appRoutes.legislationDetails,
      gridArea: "legislation",
      textPlacement: TextPlacement.left,
    },
    {
      id: 2,
      title: t("view.legislation.majorEvents"),
      backgroundColor: COLORS.Yellow,
      textColor: COLORS.RaisinBlack,
      svg: <RoundedQuarterCircle />,
      svgPosition: { top: "0px", right: "0px" },
      height: "major-events",
      svgTransform: "none",
      svgOpacity: 0.6,
      route: appRoutes.legislationEvents,
      gridArea: "major-events",
      textPlacement: TextPlacement.left,
    },
    {
      id: 3,
      title: t("view.legislation.chiefOrders"),
      backgroundColor: COLORS.Yellow,
      textColor: COLORS.RaisinBlack,
      svg: <Megaphone />,
      svgPosition: { bottom: "10px", left: "10px" },
      height: "dsu-orders",
      route: appRoutes.legislationOrders,
      gridArea: "dsu-orders",
      textPlacement: TextPlacement.right,
    },
    {
      id: 4,
      title: t("view.legislation.interministerial"),
      backgroundColor: COLORS.FaluRed,
      textColor: COLORS.Background,
      svg: <RoundedQuarterCircle />,
      svgPosition: { bottom: "0px", left: "0px" },
      height: "interministerial",
      svgTransform: "rotate(0.5turn)",
      svgOpacity: 0.15,
      route: appRoutes.legislationConsults,
      gridArea: "interministerial",
      textPlacement: TextPlacement.left,
    },
    {
      id: 5,
      title: t("view.legislation.cnsuDecisions"),
      backgroundColor: COLORS.FaluRed,
      textColor: COLORS.Background,
      svg: <RoundedQuarterCircle />,
      svgPosition: { bottom: "0px", right: "0px" },
      height: "cnsu-decisions",
      svgTransform: "rotate(1.25turn)",
      svgOpacity: 0.15,
      route: appRoutes.legislationDecisions,
      gridArea: "cnsu-decisions",
      textPlacement: TextPlacement.left,
    },
    {
      id: 6,
      title: t("view.legislation.authorizations"),
      backgroundColor: COLORS.Yellow,
      textColor: COLORS.RaisinBlack,
      svg: <Book />,
      svgPosition: { bottom: "10px", left: "0px" },
      height: "authorization-desk",
      route: appRoutes.legislationWindow,
      gridArea: "authorization-desk",
      textPlacement: TextPlacement.left,
    },
  ];
};
